import { FilterConfigFixed } from '@/types/filter';
import Stars from '@/components/shared/rating/Stars/Stars';
import { HCP_SCIENTIFIC_ACTIVITY_INVESTIGATOR } from '@/api/hcp';
import { FilterValue } from '../../FilterType';

const clinicalTrialFilter: FilterConfigFixed = {
  label: 'global.filters.formControls.clinicalTrialLabel',
  placeholder: 'global.filters.formControls.clinicalTrialPlaceholder',
  defaultValue: null,
  type: 'levelselect',
  format: ({ value, t }) => (
    <>
      <span>{t('global.filters.clinicalTrial')}</span>
      <Stars value={Number(value)} />
    </>
  ),
  filterGroup: 'scientificActivities',
  applyFilter: (filterValue: FilterValue) => {
    const ratingScore = Number(filterValue) || 0;
    return {
      and: [
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_INVESTIGATOR}.score_label`,
          operator: 'equals',
          values: ['national score'],
        },
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_INVESTIGATOR}.score_value`,
          operator: 'gte',
          values: [ratingScore.toString()],
        },
      ],
    };
  },
};

export default clinicalTrialFilter;
